import { setError } from '../App/ErrorsActions';
import moment from 'moment';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'MONTECARLO_ERROR';
export const LOADING = 'MONTECARLO_LOADING';
export const SUCCESS = 'MONTECARLO_SUCCESS';
export const SIM_SUCCESS = 'MONTECARLO_SIM_SUCCESS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

function successSimulation(data) {
  return {
    type: SIM_SUCCESS,
    data
  };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { allCustomFields, dates, enabledColors, mc } = getState().filters;

    const customFields = customFieldsUtils.getSelected(allCustomFields, mc);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      const tData = await worker.Throughput({
        lists: mc.selectedLists,
        labels: mc.selectedLabels,
        members: mc.selectedMembers,
        customFields,
        color: true,
        timeUnit: 'day',
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        fillMissingDates: true
      });
      dispatch(success(tData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getSimulationResults(baseData) {
  return async (dispatch, getState) => {
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { mc } = getState().filters;

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data);
    try {
      const simData = await worker.MonteCarloDelivery({
        baseData,
        date: moment(mc.date).toISOString(),
        trials: mc.trials,
        completedItems: mc.completedItems,
        scale: mc.scale
      });
      dispatch(successSimulation(simData));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
